import Dexie from 'dexie'

const zip = window.zip
const getDbNameFromUrl = (url) => url.split('?')[0].split('.')[0].split('_').pop()

function getUrl (url) {
  return new Promise((resolve, reject) => {
    const http = new XMLHttpRequest()
    http.responseType = 'blob'
    http.onload = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          resolve(http.response)
        } else {
          reject(http.response)
        }
      }
    }
    http.open('GET', url, true)
    http.send()
  })
}

function getSqlite (content) {
  return new Promise((resolve, reject) => {
    zip.createReader(new zip.BlobReader(content), function (reader) {
      reader.getEntries(function (entries) {
        if (entries.length) {
          entries[0].getData(new zip.BlobWriter(), (blob) => {
            const blobReader = new FileReader()
            blobReader.addEventListener('error', (e) => reject(e))
            blobReader.addEventListener('load', () => {
              reader.close(() => {
                resolve(blobReader.result)
              })
            })
            blobReader.readAsArrayBuffer(blob)
          })
        }
      })
    })
  })
}

const TABLES = [
  'DestinyClassDefinition',
  'DestinyDamageTypeDefinition',
  'DestinyGenderDefinition',
  'DestinyInventoryBucketDefinition',
  'DestinyInventoryItemDefinition',
  'DestinyItemCategoryDefinition',
  'DestinyItemTierTypeDefinition',
  'DestinyRaceDefinition',
  'DestinyStatDefinition'
  // 'DestinyActivityDefinition',
  // 'DestinyActivityGraphDefinition',
  // 'DestinyActivityModeDefinition',
  // 'DestinyActivityModifierDefinition',
  // 'DestinyActivityTypeDefinition',
  // 'DestinyBondDefinition',
  // 'DestinyDestinationDefinition',
  // 'DestinyEnemyRaceDefinition',
  // 'DestinyFactionDefinition',
  // 'DestinyHistoricalStatsDefinition',
  // 'DestinyLocationDefinition',
  // 'DestinyLoreDefinition',
  // 'DestinyMedalTierDefinition',
  // 'DestinyMilestoneDefinition',
  // 'DestinyObjectiveDefinition',
  // 'DestinyPlaceDefinition',
  // 'DestinyProgressionDefinition',
  // 'DestinyProgressionLevelRequirementDefinition',
  // 'DestinyRewardSourceDefinition',
  // 'DestinySackRewardItemListDefinition',
  // 'DestinySandboxPerkDefinition',
  // 'DestinySocketCategoryDefinition',
  // 'DestinySocketTypeDefinition'
  // 'DestinyStatGroupDefinition'
  // 'DestinyTalentGridDefinition',
  // 'DestinyUnlockDefinition',
  // 'DestinyVendorCategoryDefinition',
  // 'DestinyVendorDefinition'
]

function getSqliteData (database) {
  return new Promise((resolve, reject) => {
    const worker = new Worker('/static/sqlite/worker.sql.js')
    worker.onmessage = function () {
      const results = {}
      worker.onmessage = function ({data}) {
        results[data.id] = data.results[0].values.reduce((accumulated, current, i) => {
          const v = JSON.parse(current[1])
          accumulated[v.hash] = v
          return accumulated
        }, {})
        if (TABLES.length - Object.keys(results).length === 0) {
          resolve(results)
        }
      }
      TABLES.forEach((table) => {
        worker.postMessage({
          id: table,
          action: 'exec',
          sql: 'SELECT id,json FROM ' + table
        })
      })
    }
    worker.onerror = (e) => console.error('Worker errror', e)
    worker.onerrorload = (e) => console.error('Worker errror', e)
    worker.postMessage({
      id: 1,
      action: 'open',
      buffer: database
    })
  })
}

function fetchAndFillDatabase (url, db) {
  return new Promise((resolve, reject) => {
    getUrl('https://www.bungie.net' + url)
      .then(getSqlite)
      .then(getSqliteData)
      .then((definitions) => {
        const tables = Object.keys(definitions)

        console.log('got version 1')
        Promise.all(
          tables.map(table => {
            console.log('adding ' + table)
            return db[table]
              .bulkAdd(
                Object.entries(definitions[table]).map(([id, row]) => {
                  return [['id', parseInt(id)], ...Object.entries(row)].reduce((acc, [k, v]) => {
                    acc[k] = v
                    return acc
                  }, {})
                }))
              .then(() => { console.log('Table ' + table + ' created') })
          })
        ).then(() => {
          resolve(db)
        })
      })
  })
}

function cleanupDatabases (dbName, changeCallback) {
  return Dexie.getDatabaseNames().then((names) => {
    const toDelete = names.filter(name => name.startsWith('destiny-manifest')).filter(name => name !== dbName)
    if (toDelete) {
      changeCallback('Cleaning up old manifest database')
      toDelete.forEach(name => {
        Dexie.delete(name)
      })
    }
  })
}

function processIfEmpty (url, changeCallback, counts) {
  const hasEmpty = counts.find(count => count === 0) === 0
  return new Promise((resolve, reject) => {
    if (hasEmpty) {
      changeCallback('Downloading new manifest file')
      fetchAndFillDatabase(url, this.db)
        .then(resolve)
    } else {
      changeCallback('Using old manifest')
      resolve(this.db)
    }
  })
}

function fillDefinitions (db, hangeCallback) {
  return Promise.all(
    TABLES.map(table => db[table].each(item => {
      this.definitions[table][item.id] = item
    }))
  )
}

class Database {
  constructor () {
    this.definitions = TABLES.reduce((acc, table) => {
      acc[table] = {}
      return acc
    }, {})
  }

  createDb (dbName) {
    this.db = new Dexie(dbName)
    this.db.version(1).stores(TABLES.reduce((acc, table) => {
      acc[table] = 'id'
      return acc
    }, {}))
  }

  load (version, url, changeCallback) {
    changeCallback('Loading manifest')
    return new Promise((resolve, reject) => {
      this.createDb('destiny-manifest-' + getDbNameFromUrl(url))
      this.db.open().then(() => {
        Promise.all(TABLES.map(table => database.db[table].count()))
          .then(processIfEmpty.bind(this, url, changeCallback))
          .then(fillDefinitions.bind(this, this.db, changeCallback))
          .then(cleanupDatabases.bind(this, this.db.name, changeCallback))
          .then(() => {
            changeCallback('Manifest loaded')
            resolve(this)
          })
      })
    })
  }

  getClass (classHash) {
    return this.definitions.DestinyClassDefinition[classHash]
  }

  getRace (raceHash) {
    return this.definitions.DestinyRaceDefinition[raceHash]
  }

  getItemDefinition (itemHash) {
    return this.definitions.DestinyInventoryItemDefinition[itemHash]
  }

  getCategory (categoryId) {
    return this.definitions.DestinyItemCategoryDefinition[categoryId]
  }

  getDamageType (damageTypeHash) {
    return this.definitions.DestinyDamageTypeDefinition[damageTypeHash]
  }

  getInventoryBucket (inventoryBucketHash) {
    return this.definitions.DestinyInventoryBucketDefinition[inventoryBucketHash]
  }

  getTierType (tierTypeHash) {
    return this.definitions.DestinyItemTierTypeDefinition[tierTypeHash]
  }

  getStat (statHash) {
    return this.definitions.DestinyStatDefinition[statHash]
  }
}

const database = new Database()
if (process.env.NODE_ENV !== 'production') {
  window.database = database
}

export default database



// WEBPACK FOOTER //
// ./src/utils/database.js